import React, { useEffect } from "react"
import { Card } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { UnsavedChangesProvider } from "@/components/Wizard/UnsavedChangesContext"

import _ from "lodash"

import LoadingSpinner from "@/components/LoadingSpinner"
import Wizard from "@/components/Wizard"
import SliceProvider, { useSliceSelector, useSliceActions } from "@/helpers/SliceProvider"

import createOperatorApplicationSlice from "./Slice"
import { getForm } from "./selectors"

import OperatorForm from "./pages/OperatorForm"
import AgreementForm from "./pages/AgreementForm"
import PortDetailsForm from "./pages/PortDetailsForm"

import OperatorQuestionsForm from "./pages/OperatorQuestionsForm"

import AuditView from "./pages/AuditView"

const PAGES = [
  {
    title: "Company Details",
    component: OperatorForm,
    href: "#company-details",
  },
  {
    title: "Port Details",
    component: PortDetailsForm,
    href: "#port-details",
  },
  {
    title: "Questionnaire",
    component: OperatorQuestionsForm,
    href: "#operator-questionnaire",
  },
  {
    title: "Requirements & Agreement",
    component: AgreementForm,
    href: "#confirm-agreement",
  },
]

const EDIT_MODE = "edit"
const REVIEW_MODE = "review"

const AppWithInitialization = (props) => {
  const dispatch = useDispatch()

  const { initialize } = useSliceActions()

  const { initialized, page, submitting } = useSliceSelector(getForm)

  const pages =
    props.form.mode === REVIEW_MODE
      ? _.concat(PAGES, {
          title: "Audit Trail",
          component: AuditView,
          href: "#audit-view",
        })
      : PAGES

  useEffect(() => {
    if (!initialized) {
      dispatch(initialize(props.form))
    }
  }, [initialized, dispatch, props.form])

  if (!initialized) {
    return <LoadingSpinner />
  }

  return (
    <UnsavedChangesProvider>
      <Wizard pages={pages} context={{ readOnly: props.form.mode === REVIEW_MODE }} />
    </UnsavedChangesProvider>
  )
}

const App = (props) => {
  const sliceName = props.sliceName || "operatorApplication"

  const slice = createOperatorApplicationSlice({ name: sliceName })

  return (
    <SliceProvider slice={slice}>
      <AppWithInitialization {...props} />
    </SliceProvider>
  )
}

export const AppCard = (props) => {
  const heading = `Operator Agreement between ${props.form.cruiseCompanyName} and ${props.form.operatorName}`
  const subHeading = `Complete each section to finalize your application. Once signed, ${props.form.cruiseCompanyName} will review your agreement and provide feedback.`

  return (
    <Card>
      <Card.Header className="d-inline-flex flex-column gap-4">
        <h1 className="h4 mb-0">{heading}</h1>
        {props.form.mode === EDIT_MODE && <span className="mb-0">{subHeading}</span>}
      </Card.Header>
      <Card.Body>
        <App {...props} />
      </Card.Body>
    </Card>
  )
}

export default App
